import AccessRestrictedError from './AccessRestrictedError';

export default class ChannelAccessRestrictedError extends AccessRestrictedError {}
